// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"d5b88fb0","309":"bcc6baa4","453":"f216a4ac","858":"6409729a","859":"8f85e3ea","861":"588cccd7","932":"03ce449e","946":"ad94edcc"}[chunkId] + ".chunk.js";
};